// analytics.js
import ReactGA from 'react-ga';

// Initialize Google Analytics with your tracking code
//ReactGA.initialize('G-XXXXX');
ReactGA.initialize('G-DMEXWW8GCJ');